import * as React from 'react'
import {ValidationError, ErrorType} from './types'
import {MAX_PLACEHOLDERS_ERROR_MESSAGE} from 'airship/page/api-integrations/xdf/ModalFeedForm/validator'

export interface Props {
  error: ValidationError
}

const ErrorText: React.FC<Props> = ({error}) => {
  const errorText: {[K in ErrorType]: string} = {
    [ErrorType.Invalid]: 'is invalid',
    [ErrorType.InvalidFormat]: 'Invalid format',
    [ErrorType.Required]: 'is required',
    [ErrorType.MinMaxValue]: 'First value must be lower',
    [ErrorType.MaxLength]: 'is too long',
    [ErrorType.MinLength]: 'is too short',
    [ErrorType.MaxMagnitude]: 'is too high',
    [ErrorType.MinMagnitude]: 'is too low',
    [ErrorType.HandlebarsPayloadInvalid]: 'did not pass renderer validation',
    [ErrorType.HandlebarsSyntaxInvalid]: 'contains invalid handlebars',
    [ErrorType.HandlebarsRenderingTimeout]: 'is too complex to be rendered',
    [ErrorType.HandlebarsUnsupported]: 'does not support personalization',
    [ErrorType.NoSpecialChar]: 'contains special character',
    [ErrorType.AlreadyExists]: 'already exists',
    [ErrorType.NoSpaceCharBeginOrEnd]:
      "Invalid format: attribute name can't start or end with a space character",
    [ErrorType.NoSpacesAllowed]: 'spaces are not allowed',
    [ErrorType.InvalidKeypath]: 'is not a valid keypath',
    [ErrorType.MissingUnsubscribeLink]:
      'Commercial emails must include an unsubscribe link',
    [ErrorType.DuplicateExists]: 'already exists',
    [ErrorType.MissingValue]: 'A value is required',
    [ErrorType.MissingTagValue]: 'Please choose a tag',
    [ErrorType.MissingNumberValue]: 'A number is required',
    [ErrorType.InvalidURL]: 'is an invalid URL',
    [ErrorType.DomainDoesNotMatchUrl]:
      'Enter only the domain name of your request URL',
    [ErrorType.XdfEmptyPlaceholder]:
      'empty placeholders, [[]], are not allowed',
    [ErrorType.XdfTooManyPlaceholders]: MAX_PLACEHOLDERS_ERROR_MESSAGE,
    [ErrorType.XdfDoesNotExist]: 'This external data feed does not exist',
    [ErrorType.MustStartWithLetter]: 'must start with a letter',
    [ErrorType.InternalUnderscoresOnly]:
      'invalid special character, only underscores are allowed',
    [ErrorType.MustEndWithLetterOrNumber]: 'must end with a letter or number',
    [ErrorType.AirshipReservedNamespace]: 'must not begin with "ua_"',
    [ErrorType.FeedWithThisIDAlreadyExists]:
      'a feed already exists with this feed ID',
    [ErrorType.RequiresPlainOrHtmlField]:
      'one of plain or HTML fields is required',
    [ErrorType.MissingSegmentRows]: 'segment must have at least one condition',
    [ErrorType.InvalidCidr]: 'is invalid IP and CIDR combination',
    [ErrorType.ContainsExternalPartialReference]:
      'contains a Snippet reference',
    [ErrorType.EqualInvalidFormat]: 'Expected format: 1, 123, 1.2.3, 1.2.X',
    [ErrorType.OtherOperatorsInvalidFormat]: 'Expected format: 1, 123, 1.2.3',
    [ErrorType.SingleValueRequired]: 'Only one value allowed',
    [ErrorType.PreferenceCenterRequired]:
      'Web pages must contain a preference center',
    [ErrorType.PreferenceCenterSelectionRequired]:
      'A preference center must be selected',
    [ErrorType.ChannelTypeRequired]: 'At least one channel is required.',
    [ErrorType.NoUppercaseLettersAllowed]: 'uppercase letters are not allowed.',
    [ErrorType.EqualsStandsAlone]:
      'Values cannot combine Equals with any other value comparisons.',
    [ErrorType.EqualsCantBePaired]:
      'Values cannot combine Equals with other comparison operators.',
    [ErrorType.DuplicatedRangeValues]:
      "Duplicated range comparison: 'Greater than' cannot be combined with 'Greater or equal to', etc.",
    [ErrorType.ImpossibleRangeValues]:
      'Invalid value range: lower bound must be smaller than upper bound.',
    [ErrorType.OverlappingRangeValues]:
      'This value is not limited: all values will trigger.',
    [ErrorType.MustHaveAtLeastTwoValidItems]: 'Must have at least two answers.',
    [ErrorType.Unique]: 'must be unique',
    [ErrorType.TagGroupReservedGroupName]: 'this is a reserved group key',
    [ErrorType.GetMessage]: error.message,
  }

  return <>{errorText[error.type]}</>
}

export default ErrorText
